







































































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import GenericEdit from "@/core/Generics/GenericEdit";
import RoleRequest from "../../models/security/roleRequest.model";
import { RoleRequestStatus } from "../../enums/RoleRequestStatus";
import UserBasicInformationComponent from "@/components/user-basic-information/userBasicInformation.vue";
import ResearchCenterBasicInformationComponent from "@/components/research-center-basic-information/researchCenterBasicInformation.vue";

@Component({
  components: {
    UserBasicInformationComponent,
    ResearchCenterBasicInformationComponent
  }
})
export default class RoleRequestView extends GenericEdit<RoleRequest> {
  constructor() {
    super();
    this.controller = "RoleRequest";
    this.model = new RoleRequest();
  }

  cancel() {
    this.$router.push(`${this.$router.currentRoute.path.split("/view")[0]}`);
  }

  @Watch("model.roleRequestStatus", { immediate: true })
  onRoleRequestStatus(value: RoleRequestStatus) {
    if (this.model.id && value == RoleRequestStatus.PENDIENT) {
      this.$buefy.notification.open({
        duration: 5000,
        message: `Su solicitud esta pendiente debe esperar a que su administrador dedicado cambie el estado de la misma.`,
        position: "is-bottom-right",
        type: "is-warning",
        hasIcon: true
      });
    }
  }
}
